<div class="wrapper" *ngrxLet="filterState$; let value;">
  @for (option of filterOptions; track option) {
    <div
      class="option"
      [ngClass]="{'selected': option.value === value}"
      (click)="userSelectFilterValue(option.value)">
      <span class="w-full"
      [ngClass]="{'text-green-10': option.value === value}">{{ option.name }}</span>
      @if (option.value === value) {
        <mat-icon
          svgIcon="done"
        class="text-green-10 ml-4 w-[18px] h-[18px] min-w-fit"></mat-icon>
      }
    </div>
  }
</div>
